import styled from "styled-components";

const Image = styled.img`
  width: ${props => props.maxWidth ? props.maxWidth: '100%'};
  height: ${props => props.maxHeight ? props.maxHeight: '100%'};
  @media (min-width: 600px): {
    max-width: 1000px;
  }
`;

export default Image;
